import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteDepartmentRes;
export const DeleteDepartmentTodo = createAsyncThunk('DeleteDepartment', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `superadmin/department/${id}`,
          
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteDepartmentRes = res.data
        
    } catch (error) {
        return DeleteDepartmentRes = error.response.data
    }
})
